import { userConstants } from '../constants/user.constants';
import { parseUser } from '../helpers/dspx-utils';

const normalizeUser = (user) => {
  if (!user) return user;
  // Если access находится в token, переместить на верхний уровень
  if (user.token?.access && !user.access) {
    return {
      ...user,
      access: user.token.access,
      refresh: user.token.refresh,
    };
  }
  return user;
};

let user = JSON.parse(localStorage.getItem('user'));
user = normalizeUser(user);

const initialState = user ?
	{
		apiResponseError: null,
		loggedIn: true,
		user,
		userInfo: parseUser(),
		twoFactorVerificationTypes: [],
	} : {
		loggedIn: false,
		twoFactorVerificationTypes: [],
	};

export function authentication(state = initialState, action) {
	switch (action.type) {
		case userConstants.LOGIN_REQUEST:
			return {
				loggingIn: true,
				user: action.user
			};
		case userConstants.LOGIN_SUCCESS:
			return {
				apiResponseError: null,
				loggedIn: true,
				user: normalizeUser(action.user),
					userInfo: parseUser(),
					twoFactorVerificationTypes: [],
			};
		case userConstants.LOGIN_FAILURE:
		return {
			loggedIn: false,
			user: null,
		};
		case userConstants.LOGOUT:
			return {
				loggedIn: false,
				twoFactorVerificationTypes: [],
			};
			case userConstants.TWOFACT_VERIFICATION_TYPES_RECEIVED:
				return {
					...state,
					twoFactorVerificationTypes: action.payload,
				};
		case userConstants.EMAIL_LOADED:
			return {
				...state,
				userInfo: {
					...state.userInfo,
					email: action.payload,
					isEmailLoaded: true,
				}
			}
		default:
			return state
	}
}